import { useState, type JSX } from "react"

import { Button } from "../../reusable/Button"
import {
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "../../reusable/Dialog"
import { EditSkuTags } from "./EditSkuTags"
import { Tag } from "@phosphor-icons/react"
import { cn } from "~/utils/helpers"
import { Badge } from "~/components/reusable/Badge"
import { type IVariantSummary } from "~/hooks/useVariantTableData"

type Props = {
  variantIds: string[]
  /** Pre-resolved variants for callers whose SKU store isn't hydrated. See `EditSkuTags`. */
  variantsOverride?: Pick<IVariantSummary, "variantId" | "skuIds">[]
  customTrigger?: JSX.Element
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export const EditSkuTagsDialog = ({
  variantIds,
  variantsOverride,
  customTrigger,
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange,
}: Props) => {
  const [internalOpen, setInternalOpen] = useState(false)

  const open = controlledOpen !== undefined ? controlledOpen : internalOpen
  const handleOpenChange =
    controlledOnOpenChange ||
    ((newOpen: boolean) => {
      setInternalOpen(newOpen)
    })

  const isControlled = controlledOpen !== undefined

  return (
    <DialogRoot open={open} onOpenChange={handleOpenChange}>
      {isControlled ? null : (
        <DialogTrigger requires="edit" asChild>
          {customTrigger ? (
            customTrigger
          ) : (
            <Button size="sm" variant="neutral">
              <Tag />
              Tags
            </Button>
          )}
        </DialogTrigger>
      )}
      <DialogContent
        closeButton={false}
        className="!w-fit max-w-[90vw] overflow-x-hidden p-4 gap-2"
      >
        <DialogHeader>
          <DialogTitle>
            {" "}
            <Badge variant="tagStriped" className={cn("max-h-[22px] cursor-pointer relative m-0")}>
              <span className="max-w-28 truncate leading-normal">
                {variantIds.length > 0 ? `${variantIds.length} variants` : "No variants"}
              </span>
            </Badge>
          </DialogTitle>
        </DialogHeader>
        <EditSkuTags
          variantIds={variantIds}
          variantsOverride={variantsOverride}
          onClose={() => handleOpenChange(false)}
        />
      </DialogContent>
    </DialogRoot>
  )
}
